import DisplayUser from './displayUser'

export default class CircleUser {
  id: string
  name: string
  email: string
  avatar_url: string

  constructor(data: Record<string, unknown>) {
    this.id = data.id as string
    this.name = (data.name as string) ?? 'Anonymous'
    this.email = data.email as string
    this.avatar_url = data.avatar_url as string
  }

  get displayUser(): DisplayUser {
    return new DisplayUser({
      circle_user_id: this.id,
      name: this.name,
      subtitle: 'Legacy User',
      large_avatar_url: this.avatar_url,
      small_avatar_url: this.avatar_url
    })
  }
}
